<template>
  <div class="mt-2">
    <app-timeline>
      <app-timeline-item
        :variant="labelCurso[0][materia.status]"
      >
        <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
          <h6><b>{{ materia.materia_clave }},  {{ materia.materia_nombre }}</b></h6>
          <b-badge
            pill
            variant="light-warning"
            style="cursor: pointer;"
            @click="loadetalle(materia.kardex_id, materia.materia_id);shwDetal =! shwDetal"
          >
            {{ (!shwDetal) ? 'Ver' : 'Ocultar' }} detalle
          </b-badge>
        </div>
        <!-- list materias -->
        <b-overlay
          :show="loader"
          rounded="sm"
        >
          <detalle
            v-show="shwDetal"
            :materia="materia"
            :info="info"
            :calificaciones="calificaciones"
            :modulos="modulos"
            :seriaciones="seriaciones"
            :inperiodo="periodo"
          />
        </b-overlay>
      </app-timeline-item>
    </app-timeline>
  </div>
</template>

<script>
import {
  BBadge, BOverlay,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { getCurso, detailMateria } from '../../useAlumno'
import detalle from './Detalle.vue'

export default {
  components: {
    AppTimeline,
    AppTimelineItem,
    BBadge,
    BOverlay,
    detalle,
  },
  props: {
    materia: {
      type: Object,
      default: () => {},
      required: true,
    },
    periodo: {
      type: Number,
      default: () => 0,
      required: true,
    },
  },
  data() {
    return {
      load_det: false,
      shwDetal: false,
      parciales: [],
      materias: [],
    }
  },
  setup() {
    const toast = useToast()
    const calificaciones = ref([])
    const info = ref({})
    const modulos = ref([])
    const seriaciones = ref([])
    const loader = ref(false)
    /**
     * * Return color for kardex in cursos
     */
    const labelCurso = ref([
      {
        C1: 'primary', AP: 'success', NA: 'danger', C2: 'warning',
      }])

    const loadetalle = (kdx, materia) => {
      loader.value = true
      // calificaciones del curso
      getCurso(kdx, materia).then(response => {
        calificaciones.value = response.calificaciones
        // toast({
        //   component: ToastificationContent,
        //   props: {
        //     title: 'Agregando evaluaciones',
        //     text: response.message,
        //     icon: 'CheckIcon',
        //     variant: 'success',
        //   },
        // })
        setTimeout(() => {
          loader.value = false
        }, 1000)
      }, error => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Atención',
            text: error,
            icon: 'AlertCircleIcon',
            variant: 'warning',
          },
        },
        { timeout: 10000 })
      })
      // detalle de materia
      detailMateria(materia).then(response => {
        info.value = response.info
        modulos.value = response.modulos
        seriaciones.value = response.seriaciones
        // toast({
        //   component: ToastificationContent,
        //   props: {
        //     title: 'Agregando detalle',
        //     text: response.message,
        //     icon: 'CheckIcon',
        //     variant: 'success',
        //   },
        // })
        setTimeout(() => {
          loader.value = false
        }, 1000)
      }, error => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Atención',
            text: error,
            icon: 'AlertCircleIcon',
            variant: 'warning',
          },
        },
        { timeout: 10000 })
      })
    }

    return {
      calificaciones,
      loadetalle,
      info,
      modulos,
      seriaciones,
      loader,
      // formatos
      labelCurso,

    }
  },
}
</script>

<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
li {
  list-style: none;
}
</style>
